import { createFileRoute } from "@tanstack/react-router";
import { AdSetsTab } from "@/components/admin/AdSetsTab";

export const Route = createFileRoute("/admin/ad-sets")({
  head: () => ({
    meta: [
      { title: "Ad sets · Admin · INFLOW Marketing" },
      { name: "description", content: "Leads, trials and closes broken down by ad set and campaign." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Ad sets</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Leads, trials (tag <span className="font-mono">trialob</span>) and closes (tag <span className="font-mono">close</span>) per ad set.
        </p>
      </div>
      <AdSetsTab />
    </div>
  ),
});